import React, { useEffect, useState } from "react";
import {
  getAdminPassRequests,
  updatePassRequestStatus,
} from "../../services/Employeeservice";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Spinner } from "react-bootstrap";
import { GiClick } from "react-icons/gi";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { format, parseISO } from "date-fns";
import { toast } from "react-toastify";

const AdminPassChangeRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [open, setOpen] = useState(false);

  const fetchRequests = () => {
    setLoading(true);
    getAdminPassRequests()
      .then((res) => setRequests(res.data))
      .catch(() => toast.error("Failed to load requests"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleOpen = (row) => {
    setSelectedRequest(row);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedRequest(null);
    setOpen(false);
  };

  const handleStatusChange = (status) => {
    if (!selectedRequest) return;
    updatePassRequestStatus(selectedRequest.request_id, status)
      .then(() => {
        toast.success(`Request ${status.toLowerCase()} successfully.`);
        fetchRequests();
        handleClose();
      })
      .catch((err) => {
        const msg = err?.response?.data?.error || "Action failed";
        toast.error(msg);
      });
  };

  const columns = [
    {
      name: "Employee",
      selector: (row) => row.employee_name,
      wrap: true,
    },
    {
      name: "Current Stop",
      selector: (row) => row.current_stop || "NA",
      wrap: true,
    },
    {
      name: "Current Shift",
      selector: (row) => row.current_shift || "NA",
      wrap: true,
    },
    {
      name: "Requested Stop",
      selector: (row) => row.requested_stop || "NA",
      wrap: true,
    },
    {
      name: "Requested Shift",
      selector: (row) => row.requested_shift || "NA",
      wrap: true,
    },
    {
      name: "Requested At",
      selector: (row) =>
        row.requested_at
          ? format(parseISO(row.requested_at), "dd MMM yyyy, hh:mm a")
          : "NA",
      wrap: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          className={`badge bg-${
            row.request_status === "Pending"
              ? "warning"
              : row.request_status === "Approved"
              ? "success"
              : "danger"
          }`}
        >
          {row.request_status}
        </span>
      ),
      wrap: true,
    },
    {
      name: "Action",
      cell: (row) =>
        row.request_status === "Pending" ? (
          <span
            className="badge bg-primary cursor-pointer"
            onClick={() => handleOpen(row)}
          >
            Review <GiClick className="ms-1" />
          </span>
        ) : (
          "-"
        ),
      wrap: true,
    },
  ];

  return (
    <>
      <div>
        <h5 className="text-primary">Bus Pass Change Requests</h5>
        <ol className="breadcrumb breadcrumb-arrow mb-0">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className="breadcrumb-item active">Pass Change Requests</li>
        </ol>
      </div>

      <div className="card mt-3">
        <DataTable
          columns={columns}
          data={requests}
          responsive
          noDataComponent={<div className="p-2">No requests found.</div>}
          progressPending={loading}
          progressComponent={
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          }
        />
      </div>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Review Pass Change Request</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <strong>Employee:</strong> {selectedRequest?.employee_name}
            <br />
            <strong>Current Stop:</strong> {selectedRequest?.current_stop || "NA"}
            <br />
            <strong>Current Shift:</strong>{" "}
            {selectedRequest?.current_shift || "NA"}
            <br />
            <strong>Requested Stop:</strong>{" "}
            {selectedRequest?.requested_stop || "NA"}
            <br />
            <strong>Requested Shift:</strong>{" "}
            {selectedRequest?.requested_shift || "NA"}
            <br />
            <strong>Requested At:</strong>{" "}
            {selectedRequest?.requested_at
              ? format(parseISO(selectedRequest.requested_at), "dd MMM yyyy, hh:mm a")
              : "NA"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            className="btn btn-outline-danger"
            onClick={() => handleStatusChange("Rejected")}
          >
            Reject
          </button>
          <button
            className="btn btn-primary"
            onClick={() => handleStatusChange("Approved")}
          >
            Approve
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AdminPassChangeRequests;
